import { useEffect } from 'react';

import Modal from '@mui/material/Modal';

import { colors, zIndex } from 'styles';

import { Backdrop, Box } from '@mui/material';

type ContactModalType = 'apply' | 'default';

type ContactModalProps = { onClose: () => void; isOpen: boolean; mode?: ContactModalType };

export const ContactModal = ({ isOpen, onClose }: ContactModalProps) => {
  useEffect(() => {
    const scriptId = 'hubspot-embed-script';

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/7805184.js';
      script.defer = true;
      script.id = scriptId;

      document.body.appendChild(script);
    }
  }, []);

  return (
    <Modal
      sx={{
        zIndex: zIndex.modal,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="contact-modal-title"
      aria-describedby="contact-modal-description"
      slots={{
        backdrop: (props) => (
          <Backdrop
            {...props}
            sx={{
              backdropFilter: 'blur(5px)',
              backgroundColor: 'rgba(0,0,0,0.2)',
            }}
          />
        ),
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.white,
          minHeight: '150px',
          height: '100%',
          maxHeight: '450px',
          overflow: 'auto',
          width: '100%',
          maxWidth: {
            sm: '722px',
            xxs: 'calc(100% - 40px)',
          },
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
        }}
      >
        <script src="https://js.hsforms.net/forms/embed/7805184.js" defer></script>

        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="821f51c9-6660-4b3b-9801-dedee2fa4310"
          data-portal-id="7805184"
        />
      </Box>
    </Modal>
  );
};
